import React from 'react';

import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

import { Typography } from '@mui/material';

import { useGetAccount } from '~/hooks/apis/offers/useGetAccount';

import ChatterFeed from '../Chatter/ChatterFeed';
import { CHATTER_ACCOUNT_SEED_POSTS } from '../Chatter/accountSeedPosts';

export default function AccountFeedPage() {
  const { id_account: accountId } = useParams<{ id_account: string }>();
  const { data: account } = useGetAccount(accountId);

  return (
    <>
      <Helmet>
        <title>Feed | {account?.name || accountId}</title>
      </Helmet>

      <Typography variant="h4" sx={{ mb: 2 }}>
        Feed
      </Typography>
      <ChatterFeed initialPosts={CHATTER_ACCOUNT_SEED_POSTS} scopeLabel="account" />
    </>
  );
}
